import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';

// Minimal, unobtrusive footer shown across the app. Sits at the bottom of
// `<main>` so pages with their own scroll container lose only ~28px of height.
// The copy mirrors what Inspiro Tracker shows: © YEAR INPW Technologies +
// Terms of Service + Privacy Policy links. Keep it quiet — legal boilerplate,
// not marketing.
export default function AppFooter({ variant = 'default' }) {
  const year = new Date().getFullYear();
  const isPublic = variant === 'public';
  return (
    <footer
      data-testid="app-footer"
      className={`flex-shrink-0 w-full px-6 py-2 border-t border-zinc-100 bg-white/80 backdrop-blur-sm flex items-center justify-between gap-3 text-[11px] text-zinc-400`}
    >
      <span data-testid="app-footer-copyright" className="inline-flex items-center gap-2">
        <BrandLogo size="xs" />
        <span>© {year} INPW Technologies Pvt Ltd. All rights reserved.</span>
      </span>
      <div className="flex items-center gap-4">
        <Link
          to="/terms"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-zinc-700 transition-colors"
          data-testid="footer-terms-link"
        >
          Terms of Service
        </Link>
        <Link
          to="/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-zinc-700 transition-colors"
          data-testid="footer-privacy-link"
        >
          Privacy Policy
        </Link>
      </div>
    </footer>
  );
}
